// Import vue components
import MyFooter from "./MyFooter.vue";
import LeftSidebar from "./LeftSidebar.vue";
import LeftSidebarTryout from "./LeftSidebarTryout.vue";
import MyNavbar from "./MyNavbar.vue";
import MyButton from "./MyButton.vue";
import MyBreadcrumb from "./MyBreadcrumb.vue";
import ModalClose from "./ModalClose.vue";
import MyPagination from "./MyPagination.vue";
import ForumNavbar from "./ForumNavbar.vue";
import MathAndSymbol from "./MathAndSymbol.vue";

import { FacebookLoader } from "vue-content-loader";

// font-awesome
import FontAwesomeIcon from "./fontawesome/index";

export default {
  install(Vue /*, options */) {
    Vue.component("my-footer", MyFooter);
    Vue.component("left-sidebar", LeftSidebar);
    Vue.component("left-sidebar-tryout", LeftSidebarTryout);
    Vue.component("my-navbar", MyNavbar);
    Vue.component("my-button", MyButton);
    Vue.component("my-breadcrumb", MyBreadcrumb);
    Vue.component("modal-close", ModalClose);
    Vue.component("my-pagination", MyPagination);
    Vue.component("forum-navbar", ForumNavbar);
    Vue.component("math-and-symbol", MathAndSymbol);

    Vue.component("content-loader", FacebookLoader);
    // font-awesome
    Vue.component("fa-icon", FontAwesomeIcon);
  }
};
